export const adicionarComprovante = (props,file) => {

    if (!file) {
        return;
    }

    let reader = new FileReader();
    reader.readAsDataURL(file);
    let vet = null;
    let ini = 0;
    let base64Imagem = null;
    let largura = 0;
    let altura = 0;
    if (file.type === "") {
        setTimeout(
            () => {
                vet = reader.result.split(";");
                ini = vet[0].indexOf(':') + 1;
                let imagemContentType = vet[0].substring(ini);
                ini = vet[1].indexOf(',') + 1;
                base64Imagem = vet[1].substring(ini);
                enviar(
                    props,
                    imagemContentType,
                    file.name,base64Imagem,
                    file.size,largura,
                    altura
                );
            }, 
            2000 // Aguarda dois segundos
        );
    }
    else {
        reader.onload = function (e) {
            if (file.type.match('image.*')) {
                let documento = new Image();
                documento.src = e.target.result;
                largura = documento.width;
                altura = documento.height;
            }

            vet = reader.result.split(";");
            ini = vet[1].indexOf(',') + 1;
            base64Imagem = vet[1].substring(ini);
            enviar(
                props,
                file.type,
                file.name,
                base64Imagem,
                file.size,
                largura,
                altura
            );
        }
    }
}

const enviar = (
    props,
    imagemContentType,
    fileName,
    base64Imagem,
    fileSize,
    imgLargura,
    imgAltura
) => {

    const anexo = {
        imagemContentType: imagemContentType, 
        nomeArquivo: fileName, 
        base64Imagem: base64Imagem, 
        tamanho: fileSize, 
        largura: imgLargura, 
        altura: imgAltura 
    };

    let resultado =  null;
    if (props.anexosDto.length > 0) {
        resultado = props.anexosDto.find(elemento => {
            return elemento.nomeArquivo === anexo.nomeArquivo;
        });
    }

    let tamanhoTotal = 0;
    for (let i=0; i<props.anexosDto.length; i++) {
        tamanhoTotal += props.anexosDto[i].tamanho;
    }

    if (!resultado) {
        if ((tamanhoTotal + anexo.tamanho) <= 7403370) {
            props.atualizarAnexos(anexo);
            props.setMensagem({tipo:'LIMPAR'});
        }    
        else {
            props.setMensagem({
                tipo:'problema',
                texto:'A soma dos tamanhos dos anexos não pode ultrapassar 7,4 MEGA BYTES!'
            });
        }
    }
}